(function () {
  var loader = document.getElementById('StudioJLoader');
  var root = document.documentElement;
  var sessionKey = 'studioJLoaderSeen';

  if (!loader) return;

  function hideLoader() {
    loader.classList.add('is-hidden');
    root.classList.remove('studio-j-loader-active');

    try {
      window.sessionStorage.setItem(sessionKey, 'true');
    } catch (error) {
      // Storage can be blocked in strict privacy modes; the loader should still close.
    }

    window.setTimeout(function () {
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 650);
  }

  try {
    if (window.sessionStorage.getItem(sessionKey) === 'true') {
      hideLoader();
      return;
    }
  } catch (error) {
    // Keep going if storage is unavailable.
  }

  if (document.readyState === 'complete') {
    window.setTimeout(hideLoader, 450);
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(hideLoader, 450);
    });
  }

  window.setTimeout(hideLoader, 3500);
})();